<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
          }}</span>
        <span class="masge">当前共有{{ total }}条{{ this.route.menuName }}</span>
      </div>
      <div class="header">
        <div class="left">
          <el-button type="primary" class="btn primary" @click="update">更新信息</el-button>
          <!-- <el-button v-if="tableAcl.indexOf('Push') != -1 && !system_setting.isAutoSubmitOrderToPriceMonitor" type="primary" class="btn primary" @click="push">确认上传</el-button> -->
          <SelectFilter ref="selectFilter" :options="filterOptions" :query="query" @filterChange="filterChange"
            @reset="reset"></SelectFilter>
        </div>
      </div>

      <el-table ref="multipleTable" border row-key="id" v-loading="loading" :data="tableData" :max-height="tableHeight"
        style="width: 100%" @selection-change="handleSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
        <template slot="empty">
          <div class="empty-div" :style="{ height: tableHeight + 'px' }">
            <img src="../../../../assets/noData.png" width="240" height="240" />
            <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
            <div class="empty-rest" @click="reset">恢复默认</div>
          </div>
        </template>
        <el-table-column fixed :reserve-selection="true" prop="selection" type="selection" width="55"
          align="center"></el-table-column>
        <el-table-column fixed type="index" width="55" align="center" label="序号"></el-table-column>
        <el-table-column prop="priceMonitorHospitalId" width="120" label="医院编号" show-overflow-tooltip></el-table-column>
        <!-- <el-table-column prop="priceMonitorTypeName" width="110" label="价格监管平台类型" show-overflow-tooltip></el-table-column> -->
        <el-table-column prop="goodsId" width="110" label="平台产品ID" show-overflow-tooltip></el-table-column>
        <el-table-column prop="productName" width="120" label="目录名称" show-overflow-tooltip></el-table-column>
        <el-table-column prop="regCername" width="170" label="注册证名称" show-overflow-tooltip></el-table-column>
        <!-- <el-table-column prop="shcDetailId" width="140" show-overflow-tooltip label="规格型号编码"></el-table-column> -->
        <!-- <el-table-column prop="outLookc" width="120" label="规格" show-overflow-tooltip></el-table-column> -->
        <el-table-column prop="model" width="120" label="规格型号" show-overflow-tooltip></el-table-column>
        <el-table-column prop="companyNameSc" width="140" label="生产企业" show-overflow-tooltip></el-table-column>
        <el-table-column prop="price" width="80" label="采购价格" show-overflow-tooltip></el-table-column>

        <!-- <el-table-column prop="lastMinPrice" width="100" label="上月最低价" show-overflow-tooltip></el-table-column> -->
        <el-table-column prop="linkageReferencePrice" width="100" label="联动参考价" show-overflow-tooltip></el-table-column>
        <el-table-column prop="bidPrice" width="130" label="挂网现价/中选价"></el-table-column>
        <!-- <el-table-column prop="minPrice" width="80" label="最低价" show-overflow-tooltip></el-table-column>
        <el-table-column prop="avgPrice" width="80" label="平均价" show-overflow-tooltip></el-table-column>
        <el-table-column prop="maxPrice" width="80" label="最高价" show-overflow-tooltip></el-table-column> -->
        <el-table-column prop="companyIdPs" width="170" label="配送企业编码" show-overflow-tooltip></el-table-column>
        <el-table-column prop="companyNamePs" width="140" label="配送企业名称"></el-table-column>

        <el-table-column prop="procurecatalogTypeName" width="140" show-overflow-tooltip label="商品类型"></el-table-column>
        <el-table-column prop="ybCode" width="190" label="医保医用试剂分类与代码" show-overflow-tooltip></el-table-column>
        <el-table-column prop="regCerno" width="120" label="注册证号" show-overflow-tooltip></el-table-column>
        <el-table-column prop="regEndTime" label="注册证截止日期" width="120">
          <template slot-scope="scope">
            {{
              scope.row.regEndTime
                ? parseTime(new Date(scope.row.regEndTime), "{y}-{m}-{d}")
                : ""
            }}
          </template>
        </el-table-column>
        <el-table-column prop="packOutlookc" width="140" label="包装规格" show-overflow-tooltip></el-table-column>
        <el-table-column prop="material" width="120" label="产品材质" show-overflow-tooltip></el-table-column>
        <el-table-column prop="pack" width="120" label="包装材质"></el-table-column>

        <!-- <el-table-column prop="brand" width="120" label="品牌" show-overflow-tooltip></el-table-column> -->
        <el-table-column prop="sortName" width="100" label="分类名称" show-overflow-tooltip></el-table-column>
        <el-table-column prop="nineState" width="100" label="九段线状态" show-overflow-tooltip></el-table-column>
        <el-table-column prop="companyIdTb" width="100" label="申报企业ID" show-overflow-tooltip></el-table-column>
        <el-table-column prop="companyNameTb" width="140" label="申报企业（Tb）" show-overflow-tooltip></el-table-column>
        <el-table-column prop="lastUpdateTime" label="最后修改日期" width="150">
          <template slot-scope="scope">
            {{
              scope.row.lastUpdateTime
                ? parseTime(new Date(scope.row.lastUpdateTime), "{y}-{m}-{d}")
                : ""
            }}
          </template>
        </el-table-column>
        <el-table-column prop="priceStateName" width="120" label="采购状态"></el-table-column>

        <!-- 
        <el-table-column prop="procurecatalogTypeName" width="140" show-overflow-tooltip label="采购类别"></el-table-column>
        <el-table-column prop="scBidName" width="140" label="集采批次" show-overflow-tooltip></el-table-column>
        <el-table-column prop="isMadeName" width="170" label="是否国产" show-overflow-tooltip></el-table-column>
        <el-table-column prop="oldGoodsId" width="150" label="关联老平台流水号" show-overflow-tooltip></el-table-column>
        <el-table-column prop="procurecatalogId" width="100" label="商品流水号" show-overflow-tooltip></el-table-column>
        <el-table-column prop="isBidName" width="120" label="是否中选" show-overflow-tooltip></el-table-column>
        <el-table-column prop="udiCode" width="170" label="UDI主码" show-overflow-tooltip></el-table-column>
        <el-table-column prop="regcode" width="140" show-overflow-tooltip label="注册证号ID"></el-table-column> -->
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper"
        :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange"
        :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { GetGoods, UpdatePmGoodInfos } from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import BaseListMixin from "@/mixin/baseList-mixin.js";
import {
  WhetherOptions,
  ProcurecatalogTypeOptions,
  PriceMonitorTypeOptions,
} from "@/enum";
import SelectFilter from "@/components/table-select-filter";

export default {
  mixins: [GetDataMixin, GetDataSpdMixin, BaseListMixin],
  components: {
    SelectFilter,
  },
  data () {
    return {
      GetDatasAction: GetGoods,
      WhetherOptions: WhetherOptions,
      ProcurecatalogTypeOptions: ProcurecatalogTypeOptions,
      PriceMonitorTypeOptions: PriceMonitorTypeOptions,
      filterOptions: [
        {
          name: "平台产品ID",
          type: "input",
          code: "goodsId",
        },
        {
          name: "目录名称",
          type: "input",
          code: "productName",
        },

        {
          name: "注册证名称",
          type: "input",
          code: "regCername",
        },
        // {
        //   name: "规格",
        //   type: "input",
        //   code: "outLookc"
        // },
        {
          name: "规格型号",
          type: "input",
          code: "model",
        },
        {
          name: "生产企业",
          type: "input",
          code: "companyNameSc",
        },
        {
          name: "配送企业编码",
          type: "input",
          code: "companyIdPs",
        },
        {
          name: "配送企业名称",
          type: "input",
          code: "companyNamePs",
        },
        {
          name: "注册证号",
          type: "input",
          code: "regCerno",
        },
        // {
        //   name: "是否国产",
        //   type: "select",
        //   code: "isMade",
        //   data: WhetherOptions
        // },
        // {
        //   name: "是否中选",
        //   type: "select",
        //   code: "isBid",
        //   data: WhetherOptions
        // },
        // {
        //   name: "采购类别",
        //   type: "select",
        //   code: "procurecatalogType",
        //   data: ProcurecatalogTypeOptions
        // },
        // {
        //   name: "关联老平台流水号",
        //   type: "input",
        //   code: "oldGoodsId"
        // },
        {
          name: "采购价格",
          type: "number",
          code: "price",
        },
        {
          name: "最后修改日期",
          type: "date",
          code: "lastUpdateTime",
          // defaultValue: this.getDefaultDateRange(),// [new Date(new Date().setDate(new Date().getDate() - 7)), new Date()],//],
          // startDateCode: "startDate",
          // endDateCode: 'endDate'
        },
        {
          name: "医保医用试剂分类与代码",
          type: "input",
          code: "ybCode",
        },
        // {
        //   name: "价格监管平台类型",
        //   type: "select",
        //   code: "PriceMonitorType",
        //   data: PriceMonitorTypeOptions,
        // },
      ],
      query: {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
        priceMonitorType: 1,
      },
      // 列表数据
      tableData: [],
      // 列表总数
      total: 0,
    };
  },
  methods: {
    // 获取列表
    getData () {
      this.loading = true;
      this.GetDatasAction(this.query)
        .then((res) => {
          this.tableData = res.returnData.data;
          this.total = res.returnData.totalCount;

          // this.getSpanArr(this.tableData)
        })
        .finally((res) => {
          this.loading = false;
        });
    },
    // 改变当前页
    changePage (val) {
      this.$set(this.query, "pageIndex", val);
      this.getData();
    },
    handleSizeChange (val) {
      this.$set(this.query, "pageSize", val);
      this.getData();
    },

    // 重置
    reset () {
      this.query = {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
        priceMonitorType: 1,
        orgCode :sessionStorage.getItem('orgId')
      };
      if (this.$refs["selectFilter"]) {
        this.$refs["selectFilter"].resetQuery();
      }
      this.ids = [];
      this.multipleSelection = [];
      this.multiple = true;

      if (this.$refs.multipleTable) {
        this.$refs.multipleTable.clearSelection();
      }
      this.getData();
    },
    queryChange () {
      this.$set(this.query, "pageIndex", 1);
      this.getData();
    },

    update () {
      if (!this.multipleSelection || this.multipleSelection.length == 0) {
        this.$my_message("请选择要更新的常用目录数据", "warning");
        return;
      }
      let ids = this.multipleSelection.map((item) => item.id);
      UpdatePmGoodInfos({ ids: ids }).then((res) => {
        this.$my_message("更新成功", "success");
        this.getData();
      });
    },

    getDefaultDateRange () {
      var endDate = new Date();
      var start = new Date(new Date().setDate(new Date().getDate() - 6));
      // 开始日期转换为00:00:00
      var startDate = new Date(
        `${start.getFullYear()}-${start.getMonth()}-${start.getDate()} 00:00:00`
      );

      return [startDate, endDate];
    },
  },
  mounted () {
    this.getData();
  },
  created () {
    // var dateArr = this.getDefaultDateRange();
    // this.query.startDate = this.parseTime(dateArr[0])
    // this.query.endDate = this.parseTime(dateArr[1])
  },
};
</script>

<style lang="scss" scoped></style>
